import { toast } from "react-toastify";

export const success = (message: string) => {
  toast.success(message, {
    position: "top-right",
  });
};

export const error = (message: string) => {
  toast.error(message, {
    position: "top-right",
  });
};

export const warning = (message: string) => {
  toast.warning(message, {
    position: "top-right",
  });
};

export const info = (message: string) => {
  toast.info(message, {
    position: "top-right",
  });
};

export const promise = async ({
  pendingMessage = "",
  successMessage = "",
  errorMessage = "",
  request,
}: any) => {
  await toast.promise(request, {
    pending: pendingMessage,
    success: successMessage,
    error: errorMessage,
  });
};
